import { Injectable } from '@angular/core';
import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import {
  Parameters,
  PledgeProductRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }, option) {
    const parameters: Parameters = {
      ...option,
    };
    let options: AbstractControlOptions = {};

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        // Adherents
        nombreAdherents: [entity?.parameters?.nombreAdherents || null, Validators.required],
        // Optique
        optiqueActif: [!_.isNil(entity?.parameters?.optiqueActif) ? entity?.parameters?.optiqueActif : null],
        optiqueVisions: [Array.isArray(entity?.parameters?.optiqueVisions) ? entity?.parameters?.optiqueVisions[0] : entity?.parameters?.optiqueVisions || null],
        besoinOptiqueLunettes: [entity?.parameters?.besoinOptiqueLunettes || null],
        besoinOptiqueLentilles: [entity?.parameters?.besoinOptiqueLentilles || null],
        operationMyopie: [!_.isNil(entity?.parameters?.operationMyopie) ? entity?.parameters?.operationMyopie : null],
        budgetOperationMyopie: [entity?.parameters?.budgetOperationMyopie || null],
        optiqueNotes: [entity?.parameters?.optiqueNotes || null],
        // Dentaire
        dentaireActif: [!_.isNil(entity?.parameters?.dentaireActif) ? entity?.parameters?.dentaireActif : null],
        dentaireSoins: [entity?.parameters?.dentaireSoins || []],
        besoinDentaire: [entity?.parameters?.besoinDentaire || null],
        orthodontieEnfants: [!_.isNil(entity?.parameters?.orthodontieEnfants) ? entity?.parameters?.orthodontieEnfants : null],
        dentaireNotes: [entity?.parameters?.dentaireNotes || null],
        // Soins courants
        besoinSoinsCourants: [entity?.parameters?.besoinSoinsCourants || null],
        soinsCourantsNotes: [entity?.parameters?.soinsCourantsNotes || null],
        // Hospitalisation
        besoinHospitalisation: [entity?.parameters?.besoinHospitalisation || null],
        projetMaternite: [entity?.parameters?.projetMaternite || null, Validators.required],
        hospitalisationNotes: [entity?.parameters?.hospitalisationNotes || null],
        // Medecines douces
        medecinesDoucesActif: [!_.isNil(entity?.parameters?.medecinesDoucesActif) ? entity?.parameters?.medecinesDoucesActif : null],
        besoinMedecinesDouces: [entity?.parameters?.besoinMedecinesDouces || null],
        medecinesDoucesNotes: [entity?.parameters?.medecinesDoucesNotes || null],
        // Enfants
        enfantsRattachesIds: [(entity?.parameters?.enfantsRattachesIds || []).map(String)],
        // Couverture actuelle et risque de cumul
        couvertureActuelle: [entity?.parameters?.couvertureActuelle || null, Validators.required],
        natureContratExistant: [entity?.parameters?.natureContratExistant || null],
        motifDemande: [entity?.parameters?.motifDemande || null],
        eligibiliteCss: [entity?.parameters?.eligibiliteCss || null, Validators.required],
        informeRisqueCumul: [!_.isNil(entity?.parameters?.informeRisqueCumul) ? entity?.parameters?.informeRisqueCumul : null, Validators.required],
        // RCDA bénéficiaires (noms résolus au submit)
        enfantsNoms: [entity?.parameters?.enfantsNoms || []],
        conjointNom: [entity?.parameters?.conjointNom || null],
        // General
        notesGenerales: [entity?.parameters?.notesGenerales || null],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as FormArray;
  }

  extract() {
    return this.form.value.products;
  }
}
